export default (action = 'off', paramName = 'success') => {
  const { origin, pathname, search } = window.location;

  const searchParams = new URLSearchParams(search);
  if (action === 'off' && searchParams.has(paramName)) {
    searchParams.delete(paramName);
    window.history.pushState(null, '', `${origin}${pathname}?${searchParams.toString()}`);
  } else if (action === 'on') {
    searchParams.append(paramName, true);
    window.history.pushState(null, '', `${origin}${pathname}?${searchParams.toString()}`);
  }
};
